const TransitManagement = {
  validHeader: {
    Type: 'type',
    Source: 'source',
    Destination: 'destination',
    'Transporter Ref Id': 'transporter_refid',
    'Vehicle Short Code': 'vehicle_short_code',
    'Transit Days': 'transit_days',
  },
};
module.exports = { TransitManagement };
